import Request from './request-service';

const sentErrors = new Set<string>();

const ErrorLoggerService = {
  setupGlobalErrorHandlers() {
    window.onerror = (message, source, lineno, colno, error) => {
      const msg = message?.toString() || 'Unknown error';
      const stack = error?.stack || '{}';

      this.logUnhandledError({
        error_type: 'GLOBAL_ERR_HANDLER',
        message: msg,
        stacktrace: stack,
      });
    };
    window.onunhandledrejection = (event) => {
      const message = event.reason?.message || 'Unhandled Promise rejection';
      const stack = event.reason?.stack || '{}';

      this.logUnhandledError({
        error_type: 'GLOBAL_REJ_HANDLER',
        message,
        stacktrace: stack,
      });
    };
  },

  logUnhandledError(errorDetails: any) {
    const origin = window.location.origin;
    if (origin.includes('localhost') || origin === 'https://127.0.0.1:4200') return;

    const hash = this.generateErrorHash(
      errorDetails.error_type,
      errorDetails.message,
      errorDetails.stacktrace,
    );
    console.log(sentErrors.has(hash));
    if (sentErrors.has(hash)) return;

    sentErrors.add(hash);
    Request.post('log/error', {
      ...errorDetails,
      source: 'frontend',
      severity: 'error',
      subdomain_origin: origin,
      user_agent: navigator.userAgent,
    }).catch(console.error);
  },

  generateErrorHash(message: string, source?: string, stack?: string) {
    return `${message}:${source ?? ''}:${stack ?? ''}`;
  },
};

export default ErrorLoggerService;
